export function hide(permiso:number):boolean{
    const permisos = JSON.parse(localStorage.getItem("permisos")) || [];
    for(let permis of permisos){
        if(permis.permiso == permiso){
            return false;
        }
    }
    return true;
}